export enum AppliedPlanStatus {
  AP_UNSET_STATE = 'AP_UNSET_STATE', // Do not use, needed because of proto3 limitations
  AP_PROCESSING = 'AP_PROCESSING',
  AP_ACTIVATED = 'AP_ACTIVATED',
  AP_EXPIRED = 'AP_EXPIRED',
  AP_TERMINATED = 'AP_TERMINATED',
  AP_FAILED = 'AP_FAILED',
  AP_THRESHOLD_REACHED = 'AP_THRESHOLD_REACHED',
}
